import {useEffect,useState} from "react";
import {Link} from "wouter";
export function SalesCallbackBanner() {
  const [counts,setCounts]=useState<{dueCount:number;soonCount:number}|null>(null);
  useEffect(()=>{
    const controller=new AbortController();
    const load=async()=>{
      try {const token=localStorage.getItem("ayrshire_token");const r=await fetch("/api/admin/sales-follow-ups",{headers:token?{Authorization:`Bearer ${token}`}:{},signal:controller.signal});if(r.ok) setCounts(await r.json());} catch {}
    };
    void load();const timer=setInterval(()=>void load(),30000);
    window.addEventListener("focus",load);window.addEventListener("sales-follow-ups-changed",load);
    return()=>{controller.abort();clearInterval(timer);window.removeEventListener("focus",load);window.removeEventListener("sales-follow-ups-changed",load);};
  },[]);
  if(!counts || (!counts.dueCount && !counts.soonCount)) return null;
  return <Link href="/admin/sales?callbacks=1" className="block m-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950" role="status"><strong>Sales callbacks:</strong> {counts.dueCount} due · {counts.soonCount} due within 15 minutes. <span className="underline">View reminders</span></Link>;
}
